import React from 'react';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

/**
 * Info icon next to floating outlined label (shared Aircraft / Engine style).
 * Tooltip uses a span child + pointer-events:auto so hover works on InputLabel.
 */
export const FieldInfo = ({ title }) => (
  <Tooltip
    title={title || ''}
    arrow
    placement="top"
    enterTouchDelay={0}
    interactive
    PopperProps={{
      disablePortal: false,
      style: { zIndex: 2000 },
    }}
  >
    <span
      className="engine-label-info"
      tabIndex={0}
      role="button"
      aria-label="Field information"
      onClick={(e) => e.preventDefault()}
      onMouseDown={(e) => e.preventDefault()}
    >
      <InfoIcon color="primary" style={{ fontSize: 14 }} />
    </span>
  </Tooltip>
);

/** Floating label: text + required * + optional badge + info icon */
export const outlinedLabel = (text, { required = false, tip, badge } = {}) => (
  <span className="engine-outlined-label">
    {text}
    {required ? <span className="engine-req"> *</span> : null}
    {badge ? <span className="engine-internal-badge">{badge}</span> : null}
    {tip ? <FieldInfo title={tip} /> : null}
  </span>
);

export default outlinedLabel;
